import { Component, OnInit } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { SettingsService } from 'src/app/services/site/settings.service';
import { DomSanitizer } from '@angular/platform-browser'; 
import { CmsService } from 'src/app/services/api/cms.service';

@Component({
  selector: 'app-footer-checkout',
  templateUrl: './footer-checkout.component.html',
  styleUrls: ['./footer-checkout.component.scss']
})
export class FooterCheckoutComponent implements OnInit {

  date = new Date();
  year: any = '';

  constructor(
    public lang: LangService,
    public site: SettingsService,
    public cms: CmsService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.year = this.date.getFullYear();
  }

}
